export var SymetricalCryptographyTypes;
(function (SymetricalCryptographyTypes) {
    SymetricalCryptographyTypes[SymetricalCryptographyTypes["DES"] = 0] = "DES";
    SymetricalCryptographyTypes[SymetricalCryptographyTypes["TripleDES"] = 1] = "TripleDES";
    SymetricalCryptographyTypes[SymetricalCryptographyTypes["Rijndael"] = 2] = "Rijndael";
    SymetricalCryptographyTypes[SymetricalCryptographyTypes["RC2"] = 3] = "RC2";
    SymetricalCryptographyTypes[SymetricalCryptographyTypes["Aes"] = 4] = "Aes";
})(SymetricalCryptographyTypes || (SymetricalCryptographyTypes = {}));
;
